import * as actionTypes from 'modules/predefinedMessages/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean?} State */
const initialState = false;

const set = () => true;
const reset = () => false;

export default createReducer(initialState, {
  [actionTypes.CREATE]: set,
  [actionTypes.UPDATE]: set,
  [actionTypes.CREATE_SUCCESS]: reset,
  [actionTypes.CREATE_FAILURE]: reset,
  [actionTypes.UPDATE_SUCCESS]: reset,
  [actionTypes.UPDATE_FAILURE]: reset,
});
